$(function() {

  // 各言語ごとにレイアウト調整するときに使う
  if(location.pathname.match('/translate/en/')) {
    $('body').addClass('is_en')
    $('.js-change_link').attr('href',`${$('.js-change_link').attr('href')}en/`)
  }
  if(location.pathname.match('/translate/zhcn/')) {
    $('body').addClass('is_zhcn')
    $('.js-change_link').attr('href',`${$('.js-change_link').attr('href')}zhcn/`)
  }
  if(location.pathname.match('/translate/zhtw/')) {
    $('body').addClass('is_zhtw')
    $('.js-change_link').attr('href',`${$('.js-change_link').attr('href')}zhtw/`)
  }
  if(location.pathname.match('/translate/ko/')) {
    $('body').addClass('is_ko')
    $('.js-change_link').attr('href',`${$('.js-change_link').attr('href')}ko/`)
  }


  // 翻訳時にタイトルにhtmlソースが入ってしまうので、textをhtmlにパースして、textに戻すという作戦
  const title = document.title
  const tempDom = document.createElement('section');
  tempDom.innerHTML = title;
  document.title = tempDom.innerText;

  var status = {
    floor: [],
    stair: [],
    type: [],
    dinner: [],
    lunch: []
  };

  window.addEventListener('load', function () {
    if (location.search === '?right') {
      $('.m-map--box').each(function (index,map) {
        doSlided(map,'gt');
      })
      doShowedStores('gt');
    }
    if (location.search !== '?right') {
      slideMap()
    }

    var floorMapButtons = $('.m-floor--building_link')
    floorMapButtons.on('click',function (e) {
      e.preventDefault();
      $(this).closest('.m-floor--building_item').siblings('.m-floor--building_item').find('.m-floor--building_link').removeClass('is_current');
      $(this).addClass('is_current');
      var map = $(this).closest('.m-map--box');
      var direction = $(this)[0].classList.contains('m-floor--building_link-TOWERS') ? 'tw' : 'gt';

      doSlided(map,direction);
    })




    // moreボタンの表示非表示を制御する関数
    function toggleMoreBtn() {
      const shopIsShowCount = $('.floor-search--item-rest.is_show').length
      const moreBtn = $('.floor-search--more')
      const moreBtnCount = 12
      if (shopIsShowCount > moreBtnCount) {
        moreBtn.addClass('is_show')
      } else {
        moreBtn.removeClass('is_show')
      }
    }

    // moreボタンをクリックしたときの処理
    $('.floor-search--more').on('click', function(e) {
    e.preventDefault();
      // 表示されているすべての要素にis_more_showクラスを追加
      $('.floor-search--item-rest.is_show').addClass('is_more_show');
      // moreボタンを非表示にする
      $(this).removeClass('is_show');
    })

    if(location.href.match('floor-12_13.php')) {
      console.log('floor-12 13 page')

      // 簡体字などにカンマが入らないので、一旦全てのカンマを削除して、カンマを振り直す
      $('.floor-search--price').each(function(index, element){
        $(element).text($(element).text().replace('，', ''));
        $(element).text($(element).text().replace(',', ''));
        const price = Number($(element).text().replace(/[^0-9]/g,''));
        $(element).text($(element).text().replace(/\d+/,price.toLocaleString()))
      });


      if(location.search.match('gt') !== null) {
        status.floor.push('gt');
        $('.floor-sort--select_input[value="gt"]').prop('checked',true);
      }
      if(location.search.match('tw') !== null) {
        status.floor.push('tw');
        $('.floor-sort--select_input[value="tw"]').prop('checked',true);
      }
      if(location.search.match('f12') !== null) {
        status.stair.push('f12');
        $('.floor-sort--select_input[value="f12"]').prop('checked',true);
      }
      if(location.search.match('f13') !== null) {
        status.stair.push('f13');
        $('.floor-sort--select_input[value="f13"]').prop('checked',true);
      }

      setSort();
      // ページ読み込み時に表示されている要素の最初の12個にis_more_showクラスを追加
      $('.floor-search--item-rest.is_show').slice(0, 12).addClass('is_more_show');
      // ページ読み込み時にmoreボタンの表示非表示を制御
      toggleMoreBtn();

      $(".m-floor--floor_link").on('click', function(e) {
        e.preventDefault();
        var direction = $(this).text().match('12F') ? 'f12' : 'f13';
        showStairMap(direction);
      })
      $('form').submit(function (e) {
        e.preventDefault();
        var checked = $('form input:checked')
        status = {
          floor: [],
          stair: [],
          type: [],
          lunch: [],
          dinner: []
        };
        checked.each(function () {
          setStatus($(this).attr('name'),$(this).val())
        })
        setSort();

        // 既存のis_more_showクラスを削除
        $('.floor-search--item-rest').removeClass('is_more_show');
        // 表示されている要素の最初の12個にis_more_showクラスを追加
        $('.floor-search--item-rest.is_show').slice(0, 12).addClass('is_more_show');
        // moreボタンの表示非表示を制御
        toggleMoreBtn();
      })
      $('.floor-sort--btn_text-reset').on('click', function () {
        var checked = $('form input:checked')
        checked.each(function () {
          $(this).attr('checked',false)
          setSort();
        })
        status = {
          floor: [],
          stair: [],
          type: [],
          lunch: [],
          dinner: []
        };
        setSort();

        // 既存のis_more_showクラスを削除
        $('.floor-search--item-rest').removeClass('is_more_show');
        // 表示されている要素の最初の12個にis_more_showクラスを追加
        $('.floor-search--item-rest.is_show').slice(0, 12).addClass('is_more_show');
        // moreボタンの表示非表示を制御
        toggleMoreBtn();
      });
    }

    if(location.href.match('floor-b1.php')) {
      setSort();
      $('form').submit(function (e) {
        e.preventDefault();
        var checked = $('form input:checked')
        status = {
          floor: [],
          stair: [],
          type: []
        };
        checked.each(function () {
          setStatus($(this).attr('name'),$(this).val())
        })
        setSort();
      })
      $('.floor-sort--btn_text-reset').on('click', function () {
        var checked = $('form input:checked')
        checked.each(function () {
          $(this).attr('checked',false)
          setSort();
        })
        status = {
          floor: [],
          stair: [],
          type: []
        };
        setSort();

      });
    }

  });

  function setSort() {

    let array = [];

    $('.floor-search--item').each(function (index,item) {
      $(item).removeClass('is_show');
      array.push($(item))
    })

    if(status.floor.length !== 0) {
      array = array.filter((item)=> {
        var floor;
        for(var i = 0; i<status.floor.length; i++) {

          if (status.floor[i] === 'tw' && $(item).data('floor') === 'tw') {
            floor = $(item);
          }
          if (status.floor[i] === 'gt' && $(item).data('floor') === 'gt') {
            floor = $(item);
          }
        }
        return floor;
      })
    }

    if(status.stair.length !== 0) {
      $('.floor-headline--floornumber').removeClass('is_show');
      status.stair.forEach((stair)=> {
        if(stair === 'f12') $('.floor-headline--floornumber-f12').addClass('is_show');
        if(stair === 'f13') $('.floor-headline--floornumber-f13').addClass('is_show');
      });
      console.log(status.stair)
      array = array.filter((item)=> {
        var stair;
        for(var i = 0; i<status.stair.length; i++) {
          if (status.stair[i] === 'f12' && $(item).data('stair') === 'f12') {
            stair = $(item);
          }
          if (status.stair[i] === 'f13' && $(item).data('stair') === 'f13') {
            stair = $(item);
          }
        }
        return stair;
      });
    }

    if(status.type.length !== 0) {
      array = array.filter((item) => {
        var type;
        for (var i = 0; i < status.type.length; i++) {
          if ($(item).data('type') === status.type[i]) {
            type = $(item);
          }
        }
        return type;
      });
    }

    // ランチとディナーの条件をマージして、どちらかの条件を満たせばOKにする
    if ((status.lunch && status.lunch.length !== 0) || (status.dinner && status.dinner.length !== 0)) {
        array = array.filter((item) => {
            var matchesCondition = false;

            // ランチの条件チェック
            if (status.lunch && status.lunch.length !== 0) {
                for (var i = 0; i < status.lunch.length; i++) {
                    switch(status.lunch[i]) {
                        case '-1000':
                            if ($(item).data('lunch') <= 1000) matchesCondition = true;
                            break;
                        case '1000-2000':
                            if ($(item).data('lunch') >= 1000 && $(item).data('lunch') <= 2000) matchesCondition = true;
                            break;
                        case '2000-':
                            if ($(item).data('lunch') >= 2000) matchesCondition = true;
                            break;
                    }
                    if (matchesCondition) break;
                }
            }

            // ディナーの条件チェック
            if (!matchesCondition && status.dinner && status.dinner.length !== 0) {
                for (var i = 0; i < status.dinner.length; i++) {
                    switch(status.dinner[i]) {
                        case '-2000':
                            if ($(item).data('dinner') <= 2000) matchesCondition = true;
                            break;
                        case '2000-5000':
                            if ($(item).data('dinner') >= 2000 && $(item).data('dinner') <= 5000) matchesCondition = true;
                            break;
                        case '5000-':
                            if ($(item).data('dinner') >= 5000) matchesCondition = true;
                            break;
                    }
                    if (matchesCondition) break;
                }
            }

            return matchesCondition;
        });
    }


    array.forEach(function (item) {
      $(item).addClass('is_show');
    })
    $('#floorCount').text(array.length);
  }

  // this function makes map slide when first access.
  function slideMap() {
    if ($('.m-floor--map-slider').length === 0) return;

    $('.m-map--box').each(function (index,map) {
      if ($(map).hasClass('m-map--box-tw')) {
        doSlided(map,'tw');
      }
      if ($(map).hasClass('m-map--box-gt')) {
        doSlided(map,'gt');
      }
    })
  }

  /**
   *
   * @param map {Object} : map object. (m-map--box)
   * @param direction {String} : tw or gt
   */
  function doSlided(map,direction) {
    var scrollBarWidth = 30; // For, scrollBar Width miscalculate
    var wrapWidth = $(map).find('.m-floor--map').outerWidth();
    var mapWidth = $(map).find('.m-floor--map_box').outerWidth();

    $(map).removeClass('m-map--box-tw m-map--box-gt');
    $(map).find('.m-floor--map_img-left').removeClass('is_show');
    $(map).find('.m-floor--map_img-right').removeClass('is_show');
    $(map).find('.m-popup--link').each(function(index,popup){
      if($(popup).hasClass('m-popup--link-tw')) $(popup).removeClass('is_show');
      if($(popup).hasClass('m-popup--link-gt')) $(popup).removeClass('is_show');
    })

    doShowedStores(direction);

    if (direction === 'tw') {
      $(map).addClass('m-map--box-tw');
      $(map).find('.m-floor--map-slider').animate({scrollLeft: 0},400,'swing', function () {
        $(map).find('.m-floor--map_img-left').addClass('is_show');
        $(map).find('.m-popup--link').each(function(index,popup){
          if($(popup).hasClass('m-popup--link-tw')) $(popup).addClass('is_show');
        })
      })
    }

    if (direction === 'gt') {
      $(map).addClass('m-map--box-gt');
      $(map).find('.m-floor--map-slider').animate({scrollLeft: (mapWidth - wrapWidth) + scrollBarWidth},400,'swing', function () {
        $(map).find('.m-floor--map_img-right').addClass('is_show');
        $(map).find('.m-popup--link').each(function(index,popup){
          if($(popup).hasClass('m-popup--link-gt')) $(popup).addClass('is_show');
        })
      })
    }

  }

  /**
   *
   * @param parameter {String} : status object key
   * @param value {String}
   */
  function setStatus(parameter,value) {
    status[parameter].push(value);
    status[parameter] = Array.from(new Set(status[parameter]))
  }


  /**
   *
   * @param direction {String} : f13 or f12
   */
  function showStairMap(direction) {
    var maps = $('.floor-map--floor_map_box');
    var f12Map = $('.floor-map--floor_map_box-f12');
    var f13Map = $('.floor-map--floor_map_box-f13');

    maps.removeClass('is_show');
    $('.m-floor--floor_link').removeClass('is_current');
    if(direction === 'f12') {
      f12Map.addClass('is_show');
      $('.m-floor--floor_link-f12').addClass('is_current');
    }
    if(direction === 'f13') {
      f13Map.addClass('is_show');
      $('.m-floor--floor_link-f13').addClass('is_current');
    }
  }

  function doShowedStores(direction) {
    $('.floor-shop--list').each(function() {
      if($(this).hasClass('floor-shop--list-'+direction)) $(this).addClass('is_show');
      if(!$(this).hasClass('floor-shop--list-'+direction)) $(this).removeClass('is_show');
    })
  }

  // hamburger btn
  var scrollPosition;

  var ua = window.navigator.userAgent.toLowerCase();
  var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

  function bodyFixedOn() {
    if(isiOS){
      // iOS
      scrollPosition = $(window).scrollTop();
      $('body').css({
        'position': 'fixed',
        'top': '-' + scrollPosition + 'px'
      });
    }else {
      $('body').css({
        'overflow': 'hidden',
        'padding-right':'17px'
      });
      $('.cmn-header--bottom_header').css({
        'padding-right':'17px'
      });
      $('#pagetop_btn').css({
        'right':'57px'
      });
    }
  }

  function bodyFixedOff() {
    if(isiOS){
      // iOS
      $('body').css({
        'position': '',
        'top': ''
      });
      $(window).scrollTop(scrollPosition);
    }else {
      $('body').css({
        'overflow': '',
        'padding-right':''
      });
      $('.cmn-header--bottom_header').css({
        'padding-right':''
      });
      $('#pagetop_btn').css({
        'right':'40px'
      });
    }
  }

  $('#hamburger_btn').on('click', function() {
    $.when(
      $('#hamburger_btn, .cmn-header--hamburger_border, body').toggleClass('is_show'),
      $('.cmn-nav').stop(true,true).fadeToggle()
    ).done(function(){
      $('.cmn-nav_content').toggleClass('is_show');

      setTimeout(function(){
        $('.cmn-nav--category_content').stop(true,true).slideToggle(500);
        $('.cmn-nav--bg').stop(true,true).fadeToggle(500);
      },300);

      if ($('body').hasClass('is_show')) {
        bodyFixedOn();
        $('.cmn-footer').css({'z-index':9});
      } else {
        bodyFixedOff();
        $('.cmn-footer').css({'z-index':99999});
      }
    });
  })


  // language pulldown
  $('.cmn-header--language').on('click', function() {
    $(this).next('ul').slideToggle(100);
  });

  $('.cmn-header--pulldown').on('mouseleave', function () {
    $(this).children('ul').slideUp(100);
  })


  // pagetop btn
  var $topBtn = $('#pagetop_btn'),
    headerHeight = $('.cmn-header').outerHeight();

  $topBtn.hide();

  $(window).on('scroll', function () {
    if ($(this).scrollTop() > headerHeight) {
      $topBtn.fadeIn();
    } else {
      $topBtn.fadeOut();
    }
  });

  var $el = $(scrollableElement('html', 'body'));

  $topBtn.on('click', function (event) {
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 500);
    return false;
  });

  function scrollableElement () {
    var i, len, el, $el, scrollable;
    for (i = 0, len = arguments.length; i < len; i++) {
      el = arguments[i],
        $el = $(el);
      if ($el.scrollTop() > 0) {
        return el;
      } else {
        $el.scrollTop(1);
        scrollable = $el.scrollTop() > 0;
        $el.scrollTop(0);
        if (scrollable) {
          return el;
        }
      }
    }
    return [];
  }


  // internal links
  $('a[href^=#]').on('click', function() {
    var headerHight = $('header').height() + 40,
      href= $(this).attr("href"),
      target = $(href == "#" || href == "" ? 'html' : href),
      position = target.offset().top-headerHight;
    $el.animate({scrollTop:position}, 500, 'swing');  //scrollTop
    return false;
  });


  // hero image
  var $slides = $('.top-hero_slide').children('.top-hero_slide--item'),
    num = $slides.length,
    count = 0,
    interval = 7000,
    $SlideHeadlineText = $('.top-hero_slide--headline > .top-hero_slide--text'),
    headlineTextStyle = {'left':'0','opacity':1};

  function topImgSlideEffect(count){
    $slides.eq(count).addClass('is_show')
      .find($SlideHeadlineText).delay(500).each(function(i) {
      $(this).delay(200 * i).animate(headlineTextStyle,1200);
    });
  }

  $SlideHeadlineText.css({'left':'2vw','opacity':0});
  topImgSlideEffect(0);

  setTimeout(slide, interval);

  function slide() {
    $slides.eq(count).removeClass('is_show')
      .find($SlideHeadlineText).fadeTo(300,0).animate({'left':'2vw'},500);
    count++;
    if(count >= num) {
      count = 0;
    }

    topImgSlideEffect(count);
    setTimeout(slide, interval);
  }


  // mapster
  $('#towersFloor').mapster({
    singleSelect : true,
    clickNavigate: true,
    altImage: 'common/images/top-floor-img-on.png',
  });

  var ww = window.innerWidth;
  $('#towersMapfb1Left').mapster({ fillColor: "DD175E" });
  $('#towersMapfb1Right').mapster({ fillColor: "125FB2" });
  $('#towersMapf1Left,#towersMapf1Right').mapster();
  $('#towersMapf2Left,#towersMapf2Right').mapster();
  $('#towersMapf12Left,#towersMapf12Right').mapster({ fillColor: "EAA242" });
  $('#towersMapf13Left,#towersMapf13Right').mapster({ fillColor: "EAA242" });
  $('#towersMapf15Left,#towersMapf15Right').mapster({ fillColor: "2A5482" });
  if(ww<=600) {
    $('#towersMapfb1Left').mapster('resize',350,0,0);
    $('#towersMapfb1Right').mapster('resize',278,0,0);
    $('#towersMapf1Left').mapster('resize',350,0,0);
    $('#towersMapf1Right').mapster('resize',201,0,0);
    $('#towersMapf2Left').mapster('resize',350,0,0);
    $('#towersMapf2Right').mapster('resize',232,0,0);
    $('#towersMapf12Left').mapster('resize',350,0,0);
    $('#towersMapf12Right').mapster('resize',282,0,0);
    $('#towersMapf13Left').mapster('resize',350,0,0);
    $('#towersMapf13Right').mapster('resize',280,0,0);
    $('#towersMapf15Left').mapster('resize',350,0,0);
    $('#towersMapf15Right').mapster('resize',292,0,0);
  } else {
    $('#towersMapfb1Left').mapster('resize',730,0,0);
    $('#towersMapfb1Right').mapster('resize',581,0,0);
    $('#towersMapf1Left').mapster('resize',774,0,0);
    $('#towersMapf1Right').mapster('resize',446,0,0);
    $('#towersMapf2Left').mapster('resize',775,0,0);
    $('#towersMapf2Right').mapster('resize',513,0,0);
    $('#towersMapf12Left').mapster('resize',780,0,0);
    $('#towersMapf12Right').mapster('resize',630,0,0);
    $('#towersMapf13Left').mapster('resize',788,0,0);
    $('#towersMapf13Right').mapster('resize',630,0,0);
    $('#towersMapf15Left').mapster('resize',724,0,0);
    $('#towersMapf15Right').mapster('resize',606,0,0);
  }


  // effect fadein
  $(window).on('scroll', function () {
    $('.m-fadein').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 200){
        $(this).addClass('m-scrollin');
      }
    });
  });


  //credit modal
  $(document).on('click',function(e) {
    if($(e.target).attr('class') == 'm-payment--btn m-payment--btn-open') {
      $('.m-modal').css({'overflow-y':'scroll'});
      $('.m-modal, .m-modal_overlay').fadeIn();
      bodyFixedOn();
    } else {
      if($(e.target).closest('.m-payment').length == 0 && $('.m-modal').css('display') == 'block') {
        // .m-paymentの外側をクリックした時の操作
        $('.m-modal').css({'overflow-y':'hidden'});
        $('.m-modal, .m-modal_overlay').fadeOut();
        bodyFixedOff();
      }
    }
  });


  //f12/13 floor map slide
  $('.floor-map--link').on('click', function () {
    var $floorMapBox = $('.floor-map--box-slider'),
        bodyWidth = $('body').innerWidth();


    if($floorMapBox.hasClass('is_show')) {
      $('header').css({'z-index':9999});
      $('.m-floor--floor_list').toggle();
      $floorMapBox.removeClass('is_show');
      bodyFixedOff();
      $('.cmn-footer').css({'z-index':99999});
    } else {
      $('header').css({'z-index':1});
      $('.m-floor--floor_list').toggle();
      $floorMapBox.addClass('is_show').scrollTop(0);
      bodyFixedOn();
      $('.cmn-footer').css({'z-index':9});
    }
  });



});


window.addEventListener('load', () => {

  // レストランフロアガイドページのモーダル
  const modalOpenElms = document.querySelectorAll('.js-rest_modal_open')
  const modalCloseElms = document.querySelectorAll('.js-rest_modal_close')
  const modalElm = document.querySelector('.js-rest_modal')
  const modalItemElms = document.querySelectorAll('.js-rest_modal_item')

  modalOpenElms.forEach(elm => {
    elm.addEventListener('click', (e) => {
      e.preventDefault()

      const modalId = elm.getAttribute('data-modal')

      modalItemElms.forEach(item => {
        if (item.getAttribute('data-modal') === modalId) {
          item.classList.add('is_show')
        } else {
          item.classList.remove('is_show')
        }
      })

      modalElm.classList.add('is_show')
    })
  })

  modalCloseElms.forEach(elm => {
    elm.addEventListener('click', (e) => {
      e.preventDefault()
      modalElm.classList.remove('is_show')
    })
  })

  //　テナントを最初の表示の時にランダムにする
  const pathname = window.location.pathname
  if(pathname.match('floor-12_13.php')) {
    const $items = $('.floor-search--item')
    const shuffledItems = $items.get().sort(() => Math.random() - 0.5);
    $('.floor-search--list').append(shuffledItems);
  }

})
